import { FilterFn } from '@tanstack/react-table'

import { Select, TextField } from '@nike/eds'

export const exactStringFilter: FilterFn<any> = (row, columnId, filterValue) => {
  const rowValue = row.getValue(columnId)
  return rowValue === filterValue
}

export const includesStringFilter: FilterFn<any> = (row, columnId, filterValue) => {
  const rowValue = row.getValue(columnId)
  return Boolean(
    rowValue?.toString()?.toLowerCase()?.includes(filterValue?.toString()?.toLowerCase())
  )
}

type ColumnFiltersProps = {
  enableColumnFilters: boolean
  header: {
    column: {
      getCanFilter: () => boolean
      getFilterValue: () => string | undefined
      setFilterValue: (value: string | undefined) => void
      columnDef: {
        filterType?: 'text' | 'select'
        filterOptions?: Array<{ value: string; label: string }>
      }
    }
  }
}

export function ColumnFilters({ enableColumnFilters, header }: ColumnFiltersProps) {
  if (!enableColumnFilters || !header.column.getCanFilter()) {
    return null
  }

  const filterValue = header.column.getFilterValue() as string
  const filterType = header.column.columnDef.filterType || 'text'

  const selectOptions = [
    { value: '', label: 'All' },
    ...(header.column.columnDef.filterOptions || []),
  ]

  return (
    <div>
      {filterType === 'text' && (
        <TextField
          id='table--column-filter'
          className='table--column-filter' // *NOTE: global classname if needed to override
          value={filterValue || ''}
          onChange={(e) => header.column.setFilterValue(e.target.value || undefined)}
          label=''
          hideLabel
        />
      )}
      {filterType === 'select' && (
        <Select
          id='table--column-filter-select'
          className='table--column-filter-select'
          menuPosition='fixed'
          options={selectOptions}
          value={
            selectOptions.find((option) => option.value === filterValue) || {
              value: '',
              label: 'All',
            }
          }
          label=''
          // nolabel
          hasErrors={false}
          errorMessage=''
          message=''
          onChange={(
            newValue: { value: string | undefined } | null
          ) => header.column.setFilterValue(newValue ? newValue.value : undefined)}
        />
      )}
    </div>
  )
}

export default ColumnFilters
